import ApiService from "@/common/api.service";

export const GET_LIST_EXAMS = "/exam/list";
export const DETAIL_EXAM = "/exam/detail";
export const SAVE_EXAM = "/exam/save";
export const UPDATE_EXAM = "/exam/update";
export const DELETE_EXAM = "/exam/delete";
export const PREVIEW_EXAM_WORD = "/exam/import-word/preview";

export const SAVE_EXAM_QUESTION = "/exam-question/save";
export const UPDATE_EXAM_QUESTION = "/exam-question/update";
export const DELETE_EXAM_QUESTION = "/exam-question/delete";

export const DELETE_EXAM_QUESTION_OPTION = "/exam-question-option/delete";
export const DELETE_EXAM_QUESTION_BLANK = "/exam-question-blank/delete";
export const DELETE_EXAM_QUESTION_BLANK_OPTION = "/exam-question-blank-option/delete";

export const SET_EXAMS = "setExams";
export const SET_EXAM_DETAIL = "setExamDetail";
export const SET_EXAM_ERROR = "setExamError";

const emptyExam = () => ({
  title: "",
  slug: "",
  description: "",
  seo_title: "",
  seo_key: "",
  seo_description: "",
  seo_image: "",
  lesson_id: null,
  grade_id: null,
  subject_id: null,
  order: 0,
  status: 0,
  questions: []
});

const state = {
  errors: null,
  exams: [],
  examPagination: {},
  examDetail: emptyExam()
};

const getters = {
  listExams(state) {
    return state.exams;
  },
  examPagination(state) {
    return state.examPagination;
  },
  detailExam(state) {
    return state.examDetail;
  }
};

const actions = {
  [GET_LIST_EXAMS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query(GET_LIST_EXAMS, payload)
        .then(data => {
          context.commit(SET_EXAMS, data.data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_EXAM_ERROR, response);
          reject(response);
        });
    });
  },
  [DETAIL_EXAM](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(DETAIL_EXAM, id)
        .then(({ data }) => {
          context.commit(SET_EXAM_DETAIL, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_EXAM_ERROR, response);
          reject(response);
        });
    });
  },
  [SAVE_EXAM](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(SAVE_EXAM, payload)
        .then(data => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_EXAM_ERROR, response);
          reject(response);
        });
    });
  },
  [UPDATE_EXAM](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${UPDATE_EXAM}/${payload.id}`, payload)
        .then(data => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_EXAM_ERROR, response);
          reject(response);
        });
    });
  },
  [DELETE_EXAM](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.delete(DELETE_EXAM, id)
        .then(data => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_EXAM_ERROR, response);
          reject(response);
        });
    });
  },
  [PREVIEW_EXAM_WORD](context, payload) {
    return ApiService.post(PREVIEW_EXAM_WORD, payload);
  },
  [SAVE_EXAM_QUESTION](context, payload) {
    return ApiService.post(SAVE_EXAM_QUESTION, payload);
  },
  [UPDATE_EXAM_QUESTION](context, payload) {
    return ApiService.post(`${UPDATE_EXAM_QUESTION}/${payload.id}`, payload);
  },
  [DELETE_EXAM_QUESTION](context, id) {
    return ApiService.delete(DELETE_EXAM_QUESTION, id);
  },
  [DELETE_EXAM_QUESTION_OPTION](context, id) {
    return ApiService.delete(DELETE_EXAM_QUESTION_OPTION, id);
  },
  [DELETE_EXAM_QUESTION_BLANK](context, id) {
    return ApiService.delete(DELETE_EXAM_QUESTION_BLANK, id);
  },
  [DELETE_EXAM_QUESTION_BLANK_OPTION](context, id) {
    return ApiService.delete(DELETE_EXAM_QUESTION_BLANK_OPTION, id);
  },
  resetExamDetail(context) {
    context.commit(SET_EXAM_DETAIL, emptyExam());
  }
};

const mutations = {
  [SET_EXAMS](state, data) {
    if (data && Array.isArray(data.data)) {
      state.exams = data.data;
      state.examPagination = data;
    } else {
      state.exams = Array.isArray(data) ? data : [];
      state.examPagination = {};
    }
    state.errors = null;
  },
  [SET_EXAM_DETAIL](state, data) {
    const exam = data || emptyExam();
    exam.questions = exam.questions || [];
    state.examDetail = exam;
    state.errors = null;
  },
  [SET_EXAM_ERROR](state, error) {
    state.errors = error;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
